import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { DadosEmpresaRow } from 'src/modules/serasa/serasa.pj.types'

export type EnderecoProps = {
    empresa: DadosEmpresaRow
}

export default function Endereco({ empresa }: EnderecoProps) {
    return (
        <>
            <Divider textAlign="center">Endereço</Divider>

            <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                <GridItem label="Endereço" value={empresa.identificacao.endereco} xs={12} />
            </Grid>
        </>
    )
}
